var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import React from 'react';
/*import { useAppSelector } from '../../Store/hooks';
import { reducers } from '../../Store/store';
import { sliceSelectors } from '../../Store/sliceSelector';
import { CustomDictionary } from '../../Common/CustomDictionary';*/
import { isNullOrEmpty } from '../../../Utils/StringUtils';
import { styles } from './RowHeaderComponent.styles';
//import { configurationByName } from '../../Store/Slices/ConfigurationSlice';
import CallOutComponent from '../CallOutComponent/CallOutComponent';
import StackedBarComponent from '../StackedBarComponent/StackedBarComponent';
import { Stack, Text, TooltipHost } from '@fluentui/react';
import { useAppSelector } from '../../store/app.store';
import { assignmentDetailsSelectorById } from '../../store/Slices/AssignmentDetailsSlice';
import { RAvailUrlProvider } from '../../../common/RAvailUrlProvider';
const RowHeaderComponent = ({ rowIdentifier, isPastView }) => {
    var _a, _b, _c;
    /*const rowHeaderConfig = useAppSelector(configurationByName('RowHeader'));
    const selector = reducers.hasOwnProperty(
      rowHeaderConfig.properties.dataConfigName
    )
      ? sliceSelectors[rowHeaderConfig.properties.dataConfigName]
      : '';*/
    const Data = (_a = useAppSelector(assignmentDetailsSelectorById(rowIdentifier))) === null || _a === void 0 ? void 0 : _a.customProperties;
    const updatedData = Object.assign(Object.assign({}, Data), { RequestedEndDate: (Data === null || Data === void 0 ? void 0 : Data.RequestedEndDate) ? new Date(Data.RequestedEndDate).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        })
            : null, RequestType: (Data === null || Data === void 0 ? void 0 : Data.RequestType) && typeof Data.RequestType === 'string'
            ? (Data.RequestType.toLowerCase() === 'dse' ? 'EDE'
                : Data.RequestType.toLowerCase() === 'dsestaffing' ? 'EDEStaffing'
                    : Data.RequestType)
            : Data === null || Data === void 0 ? void 0 : Data.RequestType });
    const skillOrTitle = (Data === null || Data === void 0 ? void 0 : Data.RequestType.toLowerCase()) === 'mip' || ((_b = String(Data === null || Data === void 0 ? void 0 : Data.IsVBD)) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'true' ?
        'OneProfileProfessionalServiceName' : 'OneProfileSkillName';
    const urlProvider = new RAvailUrlProvider();
    const esxpBaseUrl = urlProvider.esxpBaseUrl().replace(/\/$/, '') + '/#/';
    const rowHeaderConfig = {
        componentname: 'RowHeader',
        properties: {
            key_attribute: {
                name: 'ResourceRequestId',
                defaultValue: 'Blank',
            },
            value_attribute: {
                type: 'custom',
                values: [
                    {
                        name: 'ResourceRequestId',
                        defaultValue: 'Blank',
                        type: 'link',
                    },
                    {
                        name: '',
                        defaultValue: '|',
                        type: 'text',
                    },
                    {
                        name: 'CustomerName',
                        defaultValue: '|',
                        type: 'link',
                    },
                    {
                        name: '',
                        defaultValue: '-',
                        type: 'text',
                    },
                    {
                        name: 'DemandSourceLink',
                        defaultValue: '|',
                        type: 'link',
                    },
                ],
            },
            subvalue_attribute: {
                type: 'custom',
                values: [
                    {
                        name: 'RequestType',
                        defaultValue: 'Blank',
                        type: 'link',
                    },
                    {
                        name: '',
                        defaultValue: ',',
                        type: 'text',
                    },
                    {
                        name: skillOrTitle,
                        defaultValue: 'Blank',
                        type: 'link',
                    },
                    {
                        name: '',
                        defaultValue: ',',
                        type: 'text',
                    },
                    {
                        name: 'RequestedEndDate',
                        defaultValue: '|',
                        type: 'link',
                    },
                ],
            },
            dataConfigName: 'assignmentDetails',
            additionalProperties: {
                isEditable: false,
            },
        },
        customTSXElement: {},
    };
    const elemtextContent = rowHeaderConfig.properties.value_attribute.type === 'custom' &&
        !isNullOrEmpty(updatedData)
        ? rowHeaderConfig.properties.value_attribute.values
            .map((e, index) => {
            if (!isNullOrEmpty(e.name) && !isNullOrEmpty(updatedData) && updatedData.hasOwnProperty(e.name)) {
                if (e.name === 'DemandSourceLink' && typeof updatedData[e.name] === 'string') {
                    const url = esxpBaseUrl.replace(/\/$/, '') + '/' + updatedData[e.name].replace(/^\//, '');
                    const lastPart = url.split('/').filter(Boolean).pop() || url;
                    return (React.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer", style: { color: '#0078d4', textDecoration: 'underline' }, key: e.name + '-' + index }, lastPart));
                }
                else {
                    return updatedData[e.name];
                }
            }
            else {
                return e.defaultValue;
            }
        })
        : null;
    const subelemtextContent = rowHeaderConfig.properties.subvalue_attribute.type === 'custom' &&
        !isNullOrEmpty(updatedData)
        ? rowHeaderConfig.properties.subvalue_attribute.values
            .map((e, index) => {
            if (!isNullOrEmpty(e.name) && !isNullOrEmpty(updatedData) && updatedData.hasOwnProperty(e.name)) {
                if (e.name === skillOrTitle && typeof updatedData[e.name] === 'string' && updatedData[e.name].length > 50) {
                    // Truncate and add ellipsis
                    return (React.createElement(TooltipHost, { content: updatedData[e.name], key: e.name + '-' + index },
                        React.createElement("span", { style: {
                                maxWidth: 200,
                                display: 'inline-block',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                verticalAlign: 'bottom',
                            } }, updatedData[e.name].slice(0, 50) + '...')));
                }
                else {
                    return updatedData[e.name];
                }
            }
            else {
                return e.defaultValue;
            }
        })
        : null;
    return (React.createElement("div", { style: styles.root },
        React.createElement("div", { style: Object.assign(Object.assign({}, styles.topsection), { flexWrap: 'wrap' }) },
            React.createElement(Stack, { horizontal: true, style: Object.assign(Object.assign({}, styles.topsection), { maxWidth: '90%' }) },
                React.createElement(TooltipHost, { content: elemtextContent, styles: styles.tooltipHostSection },
                    React.createElement(Text, { block: true, style: Object.assign({}, styles.elemtext) }, Array.isArray(elemtextContent) ? elemtextContent.map((item, idx) => React.createElement(React.Fragment, { key: idx },
                        item,
                        " ")) : elemtextContent)))),
        React.createElement("div", { style: Object.assign(Object.assign({}, styles.bottomsection), { flexWrap: 'nowrap' }) },
            React.createElement(Stack, { horizontal: true, style: { maxWidth: '75%' } },
                React.createElement(TooltipHost, { content: typeof subelemtextContent === 'string' ? subelemtextContent : undefined, styles: styles.tooltipHostSection },
                    React.createElement(Text, { block: true, style: Object.assign({}, styles.subelemtext) }, Array.isArray(subelemtextContent) ? subelemtextContent.map((item, idx) => React.createElement(React.Fragment, { key: idx },
                        item,
                        " ")) : subelemtextContent))),
            !isNullOrEmpty(updatedData) &&
                !(updatedData.hasOwnProperty('isNuance') && updatedData['isNuance'] == true) && (React.createElement(StackedBarComponent, { requestId: rowIdentifier })),
            !isNullOrEmpty(updatedData) &&
                !(updatedData.hasOwnProperty('isNuance') && updatedData['isNuance'] == true) && (React.createElement(CallOutComponent, { rowIdentifier: rowIdentifier })),
            ((_c = String(Data === null || Data === void 0 ? void 0 : Data.IsVBD)) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === 'true' && (React.createElement(TooltipHost, { content: "VBD Request" },
                React.createElement("span", { style: { marginLeft: 8, display: 'flex', alignItems: 'center', height: '60%' }, tabIndex: 0, role: "img", "aria-label": "VBD Request" },
                    React.createElement("svg", { width: "24", height: "16", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "VBD Request" },
                        React.createElement("title", null, "VBD Request"),
                        React.createElement("path", { d: "M17.5004 12.0003C20.5379 12.0003 23.0004 14.4627 23.0004 17.5003C23.0004 20.5378 20.5379 23.0003 17.5004 23.0003C14.4628 23.0003 12.0004 20.5378 12.0004 17.5003C12.0004 14.4627 14.4628 12.0003 17.5004 12.0003ZM14.8539 17.1467C14.6587 16.9514 14.3421 16.9514 14.1468 17.1467C13.9515 17.342 13.9515 17.6586 14.1468 17.8538L16.1468 19.8538C16.3421 20.0491 16.6587 20.0491 16.8539 19.8538L20.8539 15.8538C21.0492 15.6586 21.0492 15.342 20.8539 15.1467C20.6587 14.9514 20.3421 14.9514 20.1468 15.1467L16.5004 18.7931L14.8539 17.1467ZM12.0226 13.9996C11.7259 14.4629 11.4864 14.9663 11.314 15.4999L4.25278 15.5002C3.83919 15.5002 3.50391 15.8355 3.50391 16.2491V16.8267C3.50391 17.3624 3.69502 17.8805 4.04287 18.2878C5.29618 19.7555 7.26206 20.5013 10.0004 20.5013C10.5968 20.5013 11.1567 20.4659 11.6806 20.3954C11.9258 20.8903 12.2333 21.3489 12.5921 21.7618C11.7966 21.922 10.9317 22.0013 10.0004 22.0013C6.8545 22.0013 4.46849 21.0962 2.90219 19.2619C2.32242 18.583 2.00391 17.7195 2.00391 16.8267V16.2491C2.00391 15.007 3.01076 14.0002 4.25278 14.0002L12.0226 13.9996ZM10.0004 2.00488C12.7618 2.00488 15.0004 4.24346 15.0004 7.00488C15.0004 9.76631 12.7618 12.0049 10.0004 12.0049C7.23894 12.0049 5.00036 9.76631 5.00036 7.00488C5.00036 4.24346 7.23894 2.00488 10.0004 2.00488ZM10.0004 3.50488C8.06737 3.50488 6.50036 5.07189 6.50036 7.00488C6.50036 8.93788 8.06737 10.5049 10.0004 10.5049C11.9334 10.5049 13.5004 8.93788 13.5004 7.00488C13.5004 5.07189 11.9334 3.50488 10.0004 3.50488Z", fill: "currentColor" }))))),
            String(Data === null || Data === void 0 ? void 0 : Data.IsFlexiDateRequest).toLowerCase() === 'false' && (React.createElement(TooltipHost, { content: "Fixed Date Request" },
                React.createElement("span", { style: { marginLeft: 8, display: 'flex', alignItems: 'center', height: '60%' }, tabIndex: 0 },
                    React.createElement("svg", { width: "24", height: "16", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Fixed Date Request" },
                        React.createElement("title", null, "Fixed Date Request"),
                        React.createElement("path", { d: "M17.75 3C19.5449 3 21 4.45507 21 6.25V11.5505C20.5901 11.1323 20.0762 10.8164 19.5 10.6449V8.5H4.5V17.75C4.5 18.7165 5.2835 19.5 6.25 19.5H13V21H6.25C4.45507 21 3 19.5449 3 17.75V6.25C3 4.45507 4.45507 3 6.25 3H17.75ZM17.75 4.5H6.25C5.2835 4.5 4.5 5.2835 4.5 6.25V7H19.5V6.25C19.5 5.2835 18.7165 4.5 17.75 4.5ZM16 15H15.5C14.6716 15 14 15.6716 14 16.5V21.5C14 22.3284 14.6716 23 15.5 23H21.5C22.3284 23 23 22.3284 23 21.5V16.5C23 15.6716 22.3284 15 21.5 15H21V14C21 12.6193 19.8807 11.5 18.5 11.5C17.1193 11.5 16 12.6193 16 14V15ZM17.5 14C17.5 13.4477 17.9477 13 18.5 13C19.0523 13 19.5 13.4477 19.5 14V15H17.5V14ZM19.5 19C19.5 19.5523 19.0523 20 18.5 20C17.9477 20 17.5 19.5523 17.5 19C17.5 18.4477 17.9477 18 18.5 18C19.0523 18 19.5 18.4477 19.5 19Z", fill: "currentColor" }))))))));
};
export default RowHeaderComponent;
//# sourceMappingURL=RowHeaderComponent.js.map